export const menu = [
    {
        'title': 'Brand', 'path': 'brand',
        'items': [
            {'title': 'Mission', 'path': 'mission'},
            {'title': 'Purpose', 'path': 'purpose'},
            {'title': 'Values', 'path': 'values'},
            {'title': 'Tagline', 'path': 'tagline'},
            {'title': 'Positioning Statement', 'path': 'statement'},
            {'title': 'Brand Voice', 'path': 'identifiers'},
            {'title': 'Personification', 'path': 'personification'},
            {'title': 'Conclusion', 'path': 'conclusion'}
        ]
    },
    {
        'title':'Graphic elements','path':'base-graphics',
        'items':[
            {'title':'Logo','path': '#logo'},
            {'title':'Colors','path': '#colors'},
            {'title':'Typography','path': '#font'},
        ],
    },
];

